import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiClientError, api, getToken, setWorkspaceId } from '../api/client';
import posthog from '../lib/posthog';

export default function InviteAccept() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true });
      return;
    }

    if (!getToken()) {
      navigate(`/login?redirect=${encodeURIComponent(window.location.href)}`, { replace: true });
      return;
    }

    let cancelled = false;

    api.acceptInvite(token)
      .then((response) => {
        if (cancelled) return;
        setWorkspaceId(response.workspace_id);
        api.getMe().then(() => {
          posthog.capture('workspace_invite_accepted', { workspace_id: response.workspace_id });
        }).catch(() => {});
        navigate('/', { replace: true });
      })
      .catch((err) => {
        if (cancelled) return;
        if (err instanceof ApiClientError && err.status === 409) {
          const workspaceId = (err.data as { workspace_id?: string } | undefined)?.workspace_id;
          if (workspaceId) {
            setWorkspaceId(workspaceId);
          }
          navigate('/', { replace: true });
          return;
        }
        setError(err instanceof Error ? err.message : 'Could not accept invite');
      });

    return () => {
      cancelled = true;
    };
  }, [navigate, token]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-[var(--sp-4)]"
      style={{ background: 'var(--color-surface-neutral-medium-default)' }}
    >
      <div
        className="w-full max-w-[420px] rounded-[var(--radius-md)] p-[var(--sp-8)] text-center"
        style={{
          background: 'var(--color-surface-neutral-default)',
          boxShadow: 'var(--shadow-3)',
        }}
      >
        <div
          className="mx-auto mb-[var(--sp-6)] w-[48px] h-[48px] rounded-[var(--radius-md)] flex items-center justify-center text-white text-[20px] font-bold"
          style={{ background: 'var(--color-surface-action-strong-default)' }}
        >
          E
        </div>
        <h1
          className="m-0 text-[24px] font-bold"
          style={{ color: 'var(--color-text-neutral-strong)' }}
        >
          Workspace invite
        </h1>
        <p
          className="mt-[var(--sp-2)] mb-0 text-[14px]"
          style={{ color: 'var(--color-text-neutral-subtle)' }}
        >
          {error ?? 'Accepting your invite and switching you into the workspace...'}
        </p>
        {error && (
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="mt-[var(--sp-6)] h-[44px] px-[var(--sp-4)] rounded-[var(--radius-md)] text-[14px] font-semibold cursor-pointer border-0 text-white"
            style={{ background: 'var(--color-surface-action-strong-default)' }}
          >
            Sign in again
          </button>
        )}
      </div>
    </div>
  );
}
